/* tslint:disable */

/**
 */
export class MeshParamDef {
    ID_USER?: number;
    MESH_1_SIZE?: number;
    MESH_2_SIZE?: number;
    MESH_3_SIZE?: number;
    MESH_RATIO?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/mesh-param-def.ts